import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-invitation-step-messages',
  templateUrl: './step-messages.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class InvitationStepMessagesComponent {
  @Input() form!: FormGroup;
  @Input() assessmentLink = '';

  emailMode: 'edit' | 'preview' = 'edit';

  /** Preview shows the letter as participants will get it — {{assessment_link}} resolved. */
  previewBody(): string {
    const body = (this.form.value.emailBody as string) || '';
    return this.assessmentLink ? body.replace(/\{\{assessment_link\}\}/g, this.assessmentLink) : body;
  }

  /** Show a field's validation message once it's been touched (or a Send attempt marked it). */
  showError(name: string): boolean {
    const c = this.form.get(name);
    return !!c && c.invalid && c.touched;
  }
}
